import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MultiSelectDropdown } from '@gsa/afp-component-library';
import { useBidLineDetails } from '../provider/bid-line-details-provider';
import { getOptionalEcList } from '../provider/helpers';
import { getEditConflictBlock, displayCludes } from './conflicts-components';

const EditIncludesExcludesBlock = ({
  field,
  disabled,
  original,
  options,
  onSave,
  onUpdate,
}) => {
  const [selectedValues, setSelectedValues] = useState(original[field].value);

  const { optionalECs } = useBidLineDetails();
  const ecList = getOptionalEcList(optionalECs);

  const onChange = (values) => {
    setSelectedValues(values);
    onUpdate(field, values);
  };

  const onClickSave = () => {
    const stringify = (strArray) => JSON.stringify(strArray.sort());
    if (stringify(selectedValues) !== stringify(original[field].value))
      onSave(field, selectedValues);
  };
  const getForm = () => (
    <MultiSelectDropdown
      id={field}
      selectedValues={selectedValues}
      options={options}
      onChange={onChange}
      queryThreshold={1}
      chipShowValue
      disabled={disabled}
    />
  );

  const getSummary = () => {
    if (selectedValues.length > 0) return displayCludes(selectedValues, ecList);
    return <div className="margin-left-2">(None)</div>;
  };

  return getEditConflictBlock(
    original.equipment,
    field,
    getForm,
    getSummary,
    onClickSave,
    disabled,
  );
};

EditIncludesExcludesBlock.propTypes = {
  field: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  original: PropTypes.shape(Object).isRequired,
  options: PropTypes.arrayOf(Object).isRequired,
  onSave: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default EditIncludesExcludesBlock;
